import { create } from 'zustand'

import { AnswerData, MessageData } from '@store'

import { createSelectors } from '../helpers'
import { getDialogById } from './const'
interface DialogStore {
  isLoading: boolean
  currentMessages: MessageData[]
  currentAnswers: AnswerData[]
  isEnded: boolean
  actions: {
    setDialog: (id: string) => void
    handleSelectAnswer: (answer: AnswerData) => void
  }
}

export const PLAYER_AVATAR_TYPE = 'PlayerAvatar'

export const useDialogStoreBase = create<DialogStore>((set) => ({
  isLoading: false,
  currentMessages: [],
  currentAnswers: [],
  isEnded: false,
  actions: {
    setDialog: async (id) => {
      set({ isLoading: true })

      const dialog = await getDialogById(id)

      if (dialog) {
        set(() => ({
          currentAnswers: dialog.answers,
          currentMessages: dialog.messages,
          isEnded: false,
        }))
      }

      set({ isLoading: false })
    },
    handleSelectAnswer: async (answer: AnswerData) => {
      if (answer.nextId === 'end') {
        set((prev) => ({
          currentAnswers: [],
          currentMessages: [
            ...prev.currentMessages,
            {
              messageType: 'base',
              data: {
                id: answer.id,
                text: answer.text,
                author: 'You',
                avatar: PLAYER_AVATAR_TYPE,
                isPlayer: true,
              },
            },
          ],
          isEnded: true,
        }))

        return
      }

      const nextItem = await getDialogById(answer.nextId)

      if (nextItem) {
        set((prev) => ({
          currentAnswers: nextItem.answers,
          currentMessages: [
            ...prev.currentMessages,
            {
              messageType: 'base',
              data: {
                id: answer.id,
                text: answer.text,
                author: 'You',
                avatar: PLAYER_AVATAR_TYPE,
                isPlayer: true,
              },
            },
            ...nextItem.messages,
          ],
        }))
      }
    },
  },
}))

export const useDialogActions = () =>
  useDialogStoreBase((state) => state.actions)
export const useIsLoadingDialog = () =>
  useDialogStoreBase((state) => state.isLoading)

export const useDialog = createSelectors(useDialogStoreBase)
